module.exports = __webpack_public_path__ + "1793882494189/images/cloud-slash.f6f5a02.svg";